
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12.003.522C5.673.522.523 5.672.523 12.003c0 6.331 5.15 11.481 11.48 11.481 6.332 0 11.482-5.15 11.482-11.48 0-6.332-5.15-11.482-11.482-11.482"}}),_c('path',{attrs:{"d":"M12.003.522C5.673.522.523 5.672.523 12.003c0 6.331 5.15 11.481 11.48 11.481 6.332 0 11.482-5.15 11.482-11.48 0-6.332-5.15-11.482-11.482-11.482z","stroke":"#005149","stroke-width":"1.044"}}),_c('path',{attrs:{"d":"M11.671 6.66l.06.001c.699 0 1.272-.55 1.301-1.252.028-.732-.55-1.329-1.313-1.36A1.303 1.303 0 0010.423 5.3c-.03.72.53 1.33 1.248 1.36m1.282 1.822H9.759v1.152h1.425v9.169H9.887v1.152h4.361v-1.152h-1.297z","stroke":"#E0EEE8","stroke-width":".4","fill":"#005149"}})])])
          )
        }
      }
    